// import RouteView from '@/router/RouteView.vue';
import AuthorityStatistics from './AuthorityStatistics/index.vue'
import ConsumpSituation from './ConsumpSituation/index.vue';

export default [
  {
    path: '/AuthorityStatistics',
    name: 'AuthorityStatistics',
    component: AuthorityStatistics,
    meta: {
      title: '授权统计',
    },
  },
  {
    path: '/ConsumpSituation',
    name: 'ConsumpSituation',
    component: ConsumpSituation,
    meta: {
      title: '耗课情况',
    },
  },
];



// WEBPACK FOOTER //
// ./src/views/CourseStatistics/router.js